import { getGroupUsers } from '@/services/firebase'

export default ({
  data: function () {
    return {
      users: [],
      isLoadingGroupUsers: false,
    }
  },
  watch: {
    groupID: {
      immediate: true,
      handler: function (groupID, oldGroupID) {
        if (groupID) {
          this.loadGroupUsers(groupID)
        } else {
          this.users = []
        }
      },
    },
  },
  methods: {
    loadGroupUsers: async function (groupID) {
      this.isLoadingGroupUsers = true
      this.users = await getGroupUsers(groupID)
      this.isLoadingGroupUsers = false
    },
  },
})
